import { render } from "./Test.vue?vue&type=template&id=1fa38f0c"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=1fa38f0c&lang=css"

import exportComponent from "/Users/benjamin/Sites/hyper-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__